<template>
  <Row :gutter="16" style="min-height: 300px; padding: 16px;">
    <Col span="6">
      <el-button style="width: 100%;padding: 14px 20px;" type="primary" @click="add">新增就诊记录</el-button>
      <div
        style="display:flex;flex-direction: column;overflow-y: auto;"
        :style="{ maxHeight: 'calc(100vh - 269px)'}"
      >
        <record-button
          v-if="curIndex === dataSource.length"
          :active="true"
          value="新增就诊记录"
          :show_delete="false"
        ></record-button>
        <record-button
          v-for="(u, i) in dataSource"
          :key="i"
          :value="u.alias || ((u.type || '') + (u.way || ''))"
          :label="'就诊时间: ' + (u.start_time ? u.start_time.slice(0, 11) : '')"
          :active="i === curIndex"
          @click.native="edit(u, i)"
          @remove="remove(u, i)"
        />
      </div>
    </Col>
    <Col span="18">
      <Card v-if="curIndex !== -1">
        <div>
          <Form
            ref="basicForm"
            :label-width="100"
            label-position="right"
            style="margin-right: 20px;"
          >
            <FormItem
              required
              label="标题"
              style="display: inline-block; width: 47%; margin-right: calc(6% - 5px)"
            >
              <Input v-model="cur.alias" />
            </FormItem>
            <FormItem required label="就诊时间" style="display: inline-block; width: 47%;">
              <DatePicker
                v-model="cur.time"
                :transfer="true"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                :clearable="false"
                style="width: 100%"
              ></DatePicker>
            </FormItem>
            <FormItem
              required
              label="就诊类型"
              style="display: inline-block; width: 47%; margin-right: calc(6% - 5px)"
            >
              <Select v-model="cur.type">
                <Option value="门诊">门诊</Option>
                <Option value="住院">住院</Option>
              </Select>
            </FormItem>
            <FormItem required label="就诊方式" style="display: inline-block; width: 47%;">
              <Select v-model="cur.way">
                <Option value="线上">线上</Option>
                <Option value="线下">线下</Option>
              </Select>
            </FormItem>
            <!-- <FormItem label="预诊记录关联" style="display: inline-block; width: 45%;margin-right: 10px">
              <Select v-model="cur.pre_questionnaire_unique">
                <Option v-for="appoint in appointList" :key="appoint.bind_unique" :value="appoint.bind_unique">
                  {{appoint.bind_name}} {{appoint.record_time}}
                </Option>
              </Select>
            </FormItem>-->
            <!-- <el-button v-if="cur.pre_questionnaire_unique" size="small" round @click="readAppoint">查看</el-button> -->
            <!-- <el-button size="small" round type="primary" @click="addAppoint">新增</el-button> -->
            <FormItem
              label="主诉"
              prop="chief_complaint"
              style="display: inline-block; width: 47%; margin-right: calc(6% - 5px)"
            >
              <Input v-model="cur.chief_complaint" />
            </FormItem>
            <FormItem label="诊断" prop="diagnosis_code" style="display: inline-block; width: 47%;">
              <Select
                v-if="!hidden"
                v-model="cur.diagnosis_code"
                ref="query"
                filterable
                remote
                placeholder="请选择诊断"
                :loading="diagnosisLoading"
                :remote-method="getDiagnosisList"
                @on-change="setDiagnosisName"
                @on-open-change="handleQueryChange"
              >
                <Option
                  v-for="option in curDiagnosisList"
                  :value="option.icd_diagnosis_code"
                  :label="option.diagnosis_name"
                  :key="option.diagnosis_code"
                ></Option>
              </Select>
            </FormItem>
            <FormItem
              :label="cur.type + '流水号'"
              style="display: inline-block; width: 47%; margin-right: calc(6% - 5px)"
            >
              <Input v-model="cur.sn" />
            </FormItem>
            <FormItem :label="cur.type + '号'" style="display: inline-block; width: 47%; ">
              <Input v-model="cur.no" />
            </FormItem>
            <FormItem
              label="病区名称"
              style="display: inline-block; width: 47%; margin-right: calc(6% - 5px)"
            >
              <Input v-model="cur.ward_name" />
            </FormItem>
            <FormItem label="就诊科室" style="display: inline-block; width: 47%;">
              <Input v-model="cur.dept_name" />
            </FormItem>
            <FormItem
              label="主诊医生"
              style="display: inline-block; width: 47%;margin-right: calc(6% - 5px)"
            >
              <Input v-model="cur.charge_doctor" />
            </FormItem>
          </Form>
          <div style="text-align: center;">
            <el-button type="info" round @click="cancel">取消</el-button>
            <el-button :loading="loading" type="primary" round @click="save">保存</el-button>
          </div>
        </div>
      </Card>
      <div v-if="curIndex === -1 && !dataSource.length" style="position: relative; height: 300px">
        <caring-no-data />
      </div>
    </Col>
    <Modal v-model="appointModal" width="550">
      <div slot="header" style="text-align: center">
        <span>{{bind_unique ? '查看预诊记录' : '新增预诊记录'}}</span>
      </div>
      <questionIndex
        ref="question"
        :questId="bind_code"
        :uniqueId="bind_unique"
        @success="success"
      />
      <div slot="footer" style="text-align: center">
        <el-button type="info" round @click="cancelAppointModal">取消</el-button>
        <el-button
          v-if="!bind_unique"
          type="primary"
          round
          :loading="modalLoading"
          @click="saveAppoint"
        >保存</el-button>
      </div>
    </Modal>
  </Row>
</template>
<script>
import {
  updatePatientMedicalRecordApi,
  deletePatientMedicalRecordApi,
} from '../../../api/config'
import { getDiagnosis } from '../../../api/person'
import { mapGetters } from 'vuex'
import { formatDate } from '../../../utils/date'
import questionIndex from '../../question/index.vue'
import recordButton from '../components/recordButton.vue'
import CaringNoData from '../../common/caringNoData.vue'
const getDiagnosisApi = getDiagnosis
export default {
  components: {
    questionIndex,
    recordButton,
    CaringNoData,
  },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      default: () => ({}),
    },
    appointList: {
      type: Array,
      default: () => [],
    },
    appoint: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      curIndex: -1,
      cur: {
        diagnosis: '',
      },
      appointModal: false,
      bind_unique: '',
      bind_code: '',
      modalLoading: false,
      height: '',
      diagnosisLoading: false,
      diagnosisList: [],
      originList: [],
      hidden: false,
    }
  },
  computed: {
    curDiagnosisList() {
      const arr = [].concat(this.diagnosisList).concat(
        this.dataSource
          .filter((d) => d.diagnosis_code)
          .map((d) => ({
            icd_diagnosis_code: d.diagnosis_code,
            diagnosis_name: d.diagnosis,
          }))
      )

      return arr.filter(
        (d, index) =>
          arr.findIndex((a) => a.icd_diagnosis_code == d.icd_diagnosis_code) ==
          index
      )
    },
    ...mapGetters(['curDeptList']),
  },
  created() {
    if (this.dataSource.length) {
      const u = this.dataSource[0]
      this.edit(u, 0)
    }
  },
  mounted() {
    this.height = window.innerHeight - 126
  },
  methods: {
    add() {
      this.curIndex = this.dataSource.length
      this.cur = {
        alias: '就诊记录',
        sn: '',
        no: '',
        dept_code: '',
        dept_name: '',
        ward_code: '',
        ward_name: '',
        start_time: '',
        end_time: '',
        diagnosis: '',
        diagnosis_code: '',
        type: '门诊',
        way: '线下',
        time: [
          new Date(formatDate() + ' 00:00:00'),
          new Date(formatDate() + ' 23:59:59'),
        ],
        pre_questionnaire_unique: '',
      }
    },
    remove(u, i) {
      deletePatientMedicalRecordApi(u.id).then((res) => {
        if (res.code === 0) {
          this.$Message.success('删除就诊记录成功')
          if (this.curIndex === i) {
            this.curIndex = -1
          }
          setTimeout(() => {
            this.$emit('save')
          }, 1000)
        }
      })
    },
    edit(u, i) {
      this.cur = JSON.parse(JSON.stringify(u))
      this.cur.time = [
        new Date(this.cur.start_time),
        new Date(this.cur.end_time),
      ]
      this.curIndex = i
      this.hidden = true
      setTimeout(() => {
        this.hidden = false
      }, 20)
    },
    cancel() {
      this.curIndex = -1
      this.loading = false
    },
    save() {
      this.loading = true
      const [start_time, end_time] = this.cur.time
      const appoint = this.appointList.find(
        (a) => a.bind_unique === this.cur.pre_questionnaire_unique
      )
      let params = Object.assign({}, this.cur, {
        patient_id: this.info.patient_id,
        user_id: this.info.user_id,
        name: this.info.name,
        gender: this.info.gender,
        age: this.info.age,
        start_time: formatDate(new Date(start_time), 0, 'yyyy-MM-dd hh:mm:ss'),
        end_time: formatDate(new Date(end_time), 0, 'yyyy-MM-dd hh:mm:ss'),
        pre_questionnaire_id: appoint ? appoint.bind_code : '',
        pre_questionnaire_unique: appoint ? appoint.bind_unique : '',
      })
      delete params.time
      updatePatientMedicalRecordApi(params)
        .then((res) => {
          this.loading = false
          if (res.code === 0) {
            this.$Message.success('保存就诊记录成功')
            this.curIndex = -1

            setTimeout(() => {
              this.$emit('save')
            }, 1000)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    readAppoint() {
      this.bind_code = this.appoint.bind_code
      this.bind_unique = this.cur.pre_questionnaire_unique
      this.appointModal = true
    },
    addAppoint() {
      this.bind_code = this.appoint.bind_code
      this.bind_unique = ''
      this.appointModal = true
    },
    saveAppoint() {
      this.modalLoading = true
      const params = {
        patient_id: this.info.patient_id,
        user_id: this.info.user_id,
        name: this.info.name,
        module_id: this.appoint.module_id,
        module_name: this.appoint.module_name,
        business_id: this.appoint.id,
        business_name: this.appoint.name,
        business_code: this.appoint.code,
      }
      this.$refs.question.submitbtn(params, 'confirmed')
    },
    success(res) {
      this.modalLoading = false
      if (res.data.code === 0) {
        this.appointModal = false
        const { uniqueId } = res.data.data
        this.cur.pre_questionnaire_unique = uniqueId
        this.$emit('saveAppoint')
      }
    },
    cancelAppointModal() {
      this.appointModal = false
      this.modalLoading = false
    },
    setDiagnosisName(item) {
      if (item) {
        this.cur.diagnosis_name = this.curDiagnosisList.find(
          (d) => d.icd_diagnosis_code == item
        ).diagnosis_name
      } else {
        this.cur.diagnosis_name = ''
      }
    },
    handleQueryChange(query) {
      if (query && !this.cur.icd_diagnosis_code) {
        this.getDiagnosisList('')
      }
    },
    getDiagnosisList(query) {
      getDiagnosisApi({ page: 1, size: 100, name: query })
        .then((res) => {
          if (res.code === 0) {
            this.diagnosisList = res.data
          } else {
            this.$Message.error(res.message)
          }
        })
        .catch(() => {
          this.diagnosisLoading = false
        })
    },
  },
}
</script>
